"use strict";
exports.__esModule = true;
exports.DesignerTranslations = void 0;
var PieceModel_1 = require("./PieceModel");
var AccessoryModel_1 = require("./AccessoryModel");
var DesignerTranslations = /** @class */ (function () {
    function DesignerTranslations() {
    }
    DesignerTranslations.pieceSizeOptionKey = { en: "Pendant size" };
    DesignerTranslations.accessorySizeOptionKey = { en: "Necklace size" };
    DesignerTranslations.pieceSizeOptionValue = new Map([
        [PieceModel_1.PieceSize.SMALL, { en: "Small piece" }],
        [PieceModel_1.PieceSize.MEDIUM, { en: "Medium piece" }],
        [PieceModel_1.PieceSize.LARGE, { en: "Large piece" }]
    ]);
    DesignerTranslations.accessorySizeOptionValue = new Map([
        [AccessoryModel_1.AccessorySize.SMALL, { en: "Short necklace" }],
        [AccessoryModel_1.AccessorySize.MEDIUM, { en: "Medium necklace" }],
        [AccessoryModel_1.AccessorySize.LARGE, { en: "Long necklace" }]
    ]);
    DesignerTranslations.accessoryOptionKey = { en: "Necklace" };
    return DesignerTranslations;
}());
exports.DesignerTranslations = DesignerTranslations;
